/** Matches Subscription::PERIOD_TYPE_CODE_* ('M' monthly, 'Y' annual). */
export type TimePeriod = 'M' | 'Y';

export function isAnnualTimePeriod(timePeriod: string): boolean {
  return timePeriod === 'Y' || timePeriod === 'A';
}

export function isMonthlyTimePeriod(timePeriod: string): boolean {
  return timePeriod === 'M';
}
